export interface EpiEditContext {
    isEditable: boolean;
    inEditMode: boolean;
    editZIndex: number;
}

export interface EpiContextModel<T> {
    epiModel: T | null;
    epiModelTimestamp: number;
    epiModelFeilet: boolean;
}

export interface EpiContext<T> extends EpiContextModel<T> {
    locale: string;
    valuta: string;
    epiEditContext: EpiEditContext;
}

export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_VALUTA = 'UPDATE_VALUTA';
export const UPDATE_EPIMODEL = 'UPDATE_EPIMODEL';
export const UPDATE_CONTEXT = 'UPDATE_CONTEXT';
export const UPDATE_ZINDEX = 'UPDATE_ZINDEX';

export interface UpdateEpiModelAction<T> {
    type: typeof UPDATE_EPIMODEL;
    payload: EpiContextModel<T>;
}

export interface UpdateEpiContextAction<T> {
    type: typeof UPDATE_LANGUAGE;
    payload: string;
}

export interface UpdateEpiValutaAction<T> {
    type: typeof UPDATE_VALUTA;
    payload: string;
}

export interface UpdateEpiEditContext {
    type: typeof UPDATE_CONTEXT;
    payload: Partial<EpiEditContext>;
}

export interface UpdateZIndex {
    type: typeof UPDATE_ZINDEX;
    payload: number;
}

export type UpdateEpiContextActionTypes<T> =
    | UpdateEpiContextAction<T>
    | UpdateEpiModelAction<T>
    | UpdateEpiEditContext
    | UpdateZIndex
    | UpdateEpiValutaAction<T>;
